import { useState } from "react";
import useIsomorphicLayoutEffect from "../useIsomorphicLayoutEffect";
import breakpoints from "core/breakpoints";

const useSSRViewport = () => {
    const [browserWidth, setWidth] = useState(undefined);
    const [browserHeight, setHeight] = useState(undefined);

    const isMobile =
        !!browserWidth && browserWidth <= breakpoints.beforeTablet.px;

    const isTablet =
        !!browserWidth && browserWidth <= breakpoints.beforeDesktop.px;

    const isDesktop = !!browserWidth && browserWidth >= breakpoints.desktop.px;

    useIsomorphicLayoutEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleWindowResize);

        handleWindowResize();
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { browserWidth, browserHeight, isMobile, isTablet, isDesktop };
};

export default useSSRViewport;
